import { inject, injectable } from "inversify";
import { ScenarioElement } from "../../../model/playerConfiguration/ScenarioElement";
import { ScenarioPath } from "../../../model/scenarioPath/ScenarioPath";
import { TYPES } from "../../di/types";
import { MusicLayer } from "../../layer/MusicLayer";
export interface MusicLayerManager {
  play(videoCurrentTime: number, videoDuration: number): void;
  fadeOut(): void;
  changeSource(src: string): void;
  pause(): void;
  moveTo(time: number): void;
  changeVolume(volume: number): void;
  changeMuted(isMuted: boolean): void;
  initializeLayer(): void;
  setMusicTime(startTime: number, endTime: number): void;
}
@injectable()
export class MusicLayerManagerImpl implements MusicLayerManager {
  private scenarioElement: ScenarioElement;
  constructor(@inject(TYPES.layer.MusicLayer) private layer: MusicLayer) {}

  play(videoCurrentTime: number, videoDuration: number): void {
    this.layer.play(videoCurrentTime, videoDuration);
  }

  pause(): void {
    this.layer.pause();
  }

  fadeOut(): void {
    this.layer.fadeOut();
  }

  changeSource(src: string): void {
    this.layer.changeSource(src);
  }

  moveTo(time: number): void {
    this.layer.moveTo(time);
  }
 
  changeVolume(volume: number): void {
    this.layer.changeVolume(volume);
  }

  changeMuted(isMuted: boolean): void {
    this.layer.changeMuted(isMuted);
  }

  initializeLayer(): void {
    this.layer.initializeLayer();
  }

  setMusicTime(startTime: number, endTime: number): void {
    this.layer.setMusicTime(startTime, endTime);
  }
}